import React, { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Form from 'components/form/Form';
import FormGroup from 'components/form/FormGroup';
import API from 'core/Api';
import setServerErrors from 'utils/helpers/formErrors';
import { createErrorFromResponse } from 'core/Error';
import { useModal } from 'store/modal';

interface IProps {
  userInfo: {
    id: number;
    name: string;
    email: string;
  };
}

interface IInputs {
  email: string;
  password: string;
  password_confirmation: string;
}

const PasswordResetForm: FC<IProps> = ({ userInfo }: IProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { passwordResetToken } = useParams<{
    passwordResetToken: string | undefined;
  }>();
  const methods = useForm<IInputs>({
    defaultValues: {
      email: userInfo.email,
    },
  });
  const { showModal } = useModal();

  const onSubmit = (data: IInputs) => {
    return API.post('auth/password-reset', {
      password_reset_token: passwordResetToken,
      password: data.password,
      password_confirmation: data.password_confirmation,
    })
      .then(() => {
        showModal({
          type: 'success',
          content: t('auth.resetPassword.success'),
        });
        history.push('/');
      })
      .catch(err => setServerErrors(createErrorFromResponse(err).errors, methods.setError));
  };

  return (
    <Form
      methods={methods}
      onSubmit={onSubmit}
      btnLabel={t('auth.resetPassword.change')}
      hideCancelBtn
    >
      <FormGroup
        controlId="formGroupEmail"
        label={t('auth.login.email')}
        type="email"
        name="email"
        formGroupClassName="u-visibility--hidden position-absolute"
      />
      <FormGroup
        controlId="formGroupPassword"
        // label="Парола"
        type="password"
        placeholder={t('auth.resetPassword.pass')}
        name="password"
        hint={t('auth.resetPassword.passHint')}
        isPassword
        isRequired
      />

      <FormGroup
        controlId="formGroupConfirmPassword"
        // label="Повторете парола"
        type="password"
        placeholder={t('auth.resetPassword.confirmPass')}
        name="password_confirmation"
        isPassword
        isConfirmPassword
        isRequired
      />
    </Form>
  );
};

export default PasswordResetForm;
